/* eslint-disable security/detect-object-injection */
import React, {
    useCallback, useEffect
} from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { PremierConstants } from 'premier-constant-service';
import { useUpdateSubmissionServices, validationUtil } from 'premier-capability-hooks';
import presentationMetadata from "gw-capability-gateway-quoteandbind-PremierSW-react/config/PremierSW-wizard-config.json5";
import metadata from './HeaAndWellPage.metadata.json5';
import styles from '../../SpaAndWellCommonStyles.module.scss'
import ProductsCoverageSelectionComponent from '../../components/HeaAndWell/ProductsCoverageSelection/ProductsCoverageSelectionComponent';
import BusinessInformationComponent from '../../components/HeaAndWell/BusinessInformation/BusinessInformationComponent';
import GrossReceiptsComponent from '../../components/HeaAndWell/GrossReceipts/GrossReceiptsComponent';
import WetAreasComponent from '../../components/HeaAndWell/WetAreas/WetAreasComponent';
import DanceDetailsComponent from '../../components/HeaAndWell/DanceDetails/DanceDetailsComponent';
import MartialArtsComponent from '../../components/HeaAndWell/MartialArts/MartialArtsComponent';
import CyberComponent from '../../components/HeaAndWell/Cyber/CyberComponent';
import PersonalTrainingMobileComponent from '../../components/HeaAndWell/PersonalTrainingMobile/PersonalTrainingMobileComponent';
import TanningSalonOperationsComponent from '../../components/HeaAndWell/TanningSalonOperations/TanningSalonOperationsComponent';
import HealthClubFacilityComponent from '../../components/HeaAndWell/HealthClubFacility/HealthClubFacilityComponent';
import PriorLossesComponent from '../../components/HeaAndWell/PriorLosses/PriorLossesComponent';


function HeaAndWellPage(props) {


    const { wizardData: submissionVM, updateWizardData, steps, changeNextSteps } = props;
    const { updateSubmission } = useUpdateSubmissionServices();
    const { lineName } = PremierConstants;
    const offPath = 'lobData.spaAndWellLine.coverables.healthWellness'
    const propertySteps = _.filter(_.get(presentationMetadata, [`${submissionVM.value.baseData.productCode}.default.wizard`, 'steps']), (wizardStep) => wizardStep.id.includes('property'))
    const propertyCoverageSteps = _.filter(_.get(presentationMetadata, [`${submissionVM.value.baseData.productCode}.default.wizard`, 'steps']), (wizardStep) => wizardStep.id.includes('propertyCoverages'))

    const {
        onValidate,
        initialValidation
    } = useValidation('HeaAndWellPage');


    useEffect(() => {

    }, []);

    const onNext = useCallback(
        async () => {

                        const proCov = _.get(submissionVM.value, 'lobData.spaAndWellLine.coverables.healthWellness.productsCoverageSelection.proFie');
            const isProductCoverageSelected = !_.isUndefined(proCov) && proCov;

            if (isProductCoverageSelected) {
                let newSteps = steps;

                const liabilityCoveragesIndex = steps.findIndex((step) => step.id === "liabilityCoverages");

                const propertyIndex = steps.findIndex((step) => step.id === "property");

                if (propertyIndex < 0) {
                    steps.splice(liabilityCoveragesIndex + 1, 0, propertySteps[0]);
                }

                const propertyCoverageIndex = steps.findIndex((step) => step.id === "propertyCoverages");

                if (propertyCoverageIndex < 0) {
                    steps.splice(liabilityCoveragesIndex + 2, 0, propertyCoverageSteps[0]);
                }

                newSteps = steps.slice(liabilityCoveragesIndex);

                changeNextSteps(newSteps);

            } else {
                let newSteps = steps;

                const propertyIndex = steps.findIndex((step) => step.id === "property");

                if (propertyIndex >= 0) {
                    steps.splice(propertyIndex, 1);
                }

                const propertyCoverageIndex = steps.findIndex((step) => step.id === "propertyCoverages");

                if (propertyCoverageIndex >= 0) {
                    steps.splice(propertyCoverageIndex, 1);
                }

                const liabilityCoveragesIndex = steps.findIndex((step) => step.id === "liabilityCoverages");

                newSteps = steps.slice(liabilityCoveragesIndex);

                changeNextSteps(newSteps);
            }

            const { productCode } = submissionVM.value.baseData;
            const lobLineName = lineName[productCode];

            submissionVM.value = await updateSubmission(lobLineName, 'HeaAndWellPage', submissionVM);

            return submissionVM;

        },
        [lineName, submissionVM, updateSubmission]
    );

    const onSave = useCallback(
        async () => {
            const subVMCopy = _.clone(submissionVM)
            const productCode = _.get(subVMCopy.value, 'baseData.productCode');

            validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.spaAndWellLine.coverables.healthWellness.value, ' ')

            const lobLineName = productCode ? lineName[productCode] : '';
            await updateSubmission(lobLineName, 'HeaAndWellPage', subVMCopy);
                            
            return submissionVM;
        },
        [lineName, submissionVM, updateSubmission]
    );

    const overrideProps = {
        ProductsCoverageSelectionComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offPath}.productsCoverageSelection`
        },
        BusinessInformationComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offPath}.businessInformation`
        },
        GrossReceiptsComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offPath}.grossReceipts`
        },
        WetAreasComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offPath}.wetAreas`,
            visible: !_.isUndefined(_.get(submissionVM, `${offPath}.productsCoverageSelection.heaCluFie`))
                && _.get(submissionVM, `${offPath}.productsCoverageSelection.heaCluFie.value`) === true
                && _.get(submissionVM, `${offPath}.healthClubFacility.aretheanysaupooorwareFie.value`) === true
        },
        DanceDetailsComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offPath}.danceDetails`,
            visible: _.get(submissionVM, `${offPath}.productsCoverageSelection.danStuFie.value`) === true
        },
        CyberComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offPath}.cyber`,
            visible: _.get(submissionVM, `${offPath}.productsCoverageSelection.cybLiaFie.value`) === true
        },
        MartialArtsComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offPath}.martialArts`,
            visible: _.get(submissionVM, `${offPath}.productsCoverageSelection.marArtFie.value`) === true
        },
		HealthClubFacilityComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offPath}.healthClubFacility`,
            visible: _.get(submissionVM, `${offPath}.productsCoverageSelection.heaCluFie.value`) === true
        },
        PersonalTrainingMobileComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offPath}.personalTrainingMobile`,
            visible: _.get(submissionVM, `${offPath}.productsCoverageSelection.perTraFie.value`) === true
        },
        TanningSalonOperationsComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offPath}.tanningSalonOperations`,
            visible: _.get(submissionVM, `${offPath}.productsCoverageSelection.tanSalFie1.value`) === true
        },
        PriorLossesComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offPath}.priorLosses`
        },
    }

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            ProductsCoverageSelectionComponent,
            GrossReceiptsComponent,
            WetAreasComponent,
            DanceDetailsComponent,
            CyberComponent,
            BusinessInformationComponent,
            MartialArtsComponent,
			HealthClubFacilityComponent,
            PersonalTrainingMobileComponent,
            TanningSalonOperationsComponent,
            PriorLossesComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [metadata.pageContent, submissionVM, overrideProps]
    );

    const isDisableNext = () => !_.isUndefined(submissionVM.lobData) &&
        !submissionVM.lobData.spaAndWellLine.coverables.healthWellness.aspects.subtreeValid

    return (
        <WizardPage onNext={onNext} onSave={onSave} skipWhen={initialValidation} disableNext={isDisableNext()}>
            <ViewModelForm 
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}


HeaAndWellPage.propTypes = wizardProps;
export default withRouter(HeaAndWellPage);
